module.exports = __webpack_public_path__ + "media/images/icons/user-0e0d6e98cba74c67b754cc137a218527.svg";